import React from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import { actions, getters } from "../model";
import {
  getUploadDescription,
  getIsClosed,
  canAdminUserUploadContent
} from "../selectors";

import { Div } from "components/Base";
import History from "./History";

import Dropzone from "./FileDropzone";
// import UrlsTable from "./FileDropzone/UrlsTable";

import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import UnfoldLessIcon from "@material-ui/icons/UnfoldLess";
import UnfoldMoreIcon from "@material-ui/icons/UnfoldMore";
import EmptyState from "EventLight/Common/EmptyState";
import CloseAt from "./CloseAt";

import CollapsableWrapper from "EventLight/Sessions/Page/View/CollapsableWrapper";

const decorate = connect(
  state => ({
    isExpanded: getters.expanded(state),
    content: getters.content(state),
    uploadedUrls: getters.fileUploadUploadedUrls(state),
    uploadDescription: getUploadDescription(state),
    isClosed: getIsClosed(state),
    canAdminUserUploadContent: canAdminUserUploadContent(state),
    accentColor: getters.accentColor(state)
  }),
  {
    setExpanded: actions.setExpanded
  }
);

const AddContent = ({
  content,
  isExpanded,
  setExpanded,
  uploadDescription,
  isClosed,
  hasSubsessions = false,
  isSubsession = false,
  viaPortal = false,
  canAdminUserUploadContent,
  accentColor
  // uploadedUrls
}) => {
  const useStyles = makeStyles(() => ({
    buttonText: {
      textTransform: "capitalize",
      margin: 0,
      color: accentColor ? accentColor : undefined
    },
    buttonRoot: { maxWidth: 200, margin: 0 }
  }));

  // const [showUrls, setShowUrls] = useState(false);
  const classes = useStyles();

  return (
    <Div display="column" width={1} bg="neutral0" style={{ gap: "16px" }}>
      <CloseAt />

      {!canAdminUserUploadContent ||
      isClosed ||
      (!isSubsession && hasSubsessions && viaPortal) ? null : (
        <CollapsableWrapper title={"Upload Files"}>
          <Div fs={2} color="gray6">
            {uploadDescription}
          </Div>
          <Dropzone />
        </CollapsableWrapper>
      )}

      {/*
      // Hiding until we decide to support custom URLs
      <Panel>
        <PanelTitle>
          <Div
            display="row.flex-start.center"
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "row",
              alignItems: "center"
            }}
          >
            <div>Uploaded Urls</div>

            <Button
              size="small"
              color="primary"
              classes={{
                root: classes.buttonRoot,
                text: classes.buttonText
              }}
              startIcon={showUrls ? <UnfoldLessIcon /> : <UnfoldMoreIcon />}
              onClick={() => setShowUrls(!showUrls)}
            >
              {showUrls ? "Hide" : "Show"} Urls
            </Button>
          </Div>
        </PanelTitle>
        {showUrls && !R.isEmpty(uploadedUrls) && <UrlsTable uploaded />}
      </Panel>
      */}

      {/* <Panel>
        <PanelTitle>
          <Div
            display="row.flex-start.center"
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "row",
              alignItems: "center"
            }}
          >
            <div>Session Files</div>

            {!R.isEmpty(content) ? (
              <Button
                size="small"
                color="primary"
                classes={{
                  root: classes.buttonRoot,
                  text: classes.buttonText
                }}
                startIcon={isExpanded ? <UnfoldLessIcon /> : <UnfoldMoreIcon />}
                onClick={() => setExpanded(!isExpanded)}
              >
                {isExpanded ? "Contract" : "Expand"} All
              </Button>
            ) : null}
          </Div>
        </PanelTitle>

        {!R.isEmpty(content) ? (
          content.map(file => <History file={file} />)
        ) : (
          <EmptyState
            icon="upload_file"
            title="No files have been uploaded yet"
            style={{
              margin: "0px 30px 30px 30px",
              flex: 1
            }}
          />
        )}
      </Panel> */}

      <CollapsableWrapper
        title={"Session Files"}
        headingLeftComp={
          !R.isEmpty(content) ? (
            <Button
              size="small"
              color="primary"
              classes={{
                root: classes.buttonRoot,
                text: classes.buttonText
              }}
              startIcon={isExpanded ? <UnfoldLessIcon /> : <UnfoldMoreIcon />}
              onClick={e => {
                e.stopPropagation();
                setExpanded(!isExpanded);
              }}
              style={{ zIndex: 0, width: "auto" }}
            >
              {isExpanded ? "Contract" : "Expand"} All
            </Button>
          ) : null
        }
      >
        {!R.isEmpty(content) ? (
          content.map(file => <History key={file.id} file={file} />)
        ) : (
          <EmptyState
            icon="upload_file"
            title="No files have been uploaded yet"
            style={{
              margin: "0px 30px 30px 30px",
              flex: 1
            }}
          />
        )}
      </CollapsableWrapper>
    </Div>
  );
};

export default decorate(AddContent);
